<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xuZxFU/tc-custom/9780062404015.jpg?1716663165528" alt="This image is the cover for the book Mice of the Round Table: A Tail of Camelot, Mice of the Round Table"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mice of the Round Table: A Tail of Camelot, Mice of the Round Table
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An epic new middle grade series in the tradition of Redwall and Poppy, based on Arthurian legend and told from the perspective of Camelot’s most humble creatures: mice</b></p><p>With the sweeping adventure of the <i>New York Times</i> bestselling series Wings of Fire and Warriors, Mice of the Round Table brings to life a legendary world of animals and magic that kids will want to return to again and again.</p><p>Young mouse Calib Christopher aspires to be a Knight of the Round Table. For generations, his family has valiantly led the mice who live just out of sight of the humans, defending Camelot from enemies both big and small. To join the Round Table, Calib must spend his days training with other young would-be Knights. But when a new threat arises—one that could catch even the Two-Leggers off guard—it's up to Calib and his friend Cecily to unmask the real enemy, unite their forces, and save the castle they all call home.</p><p><b>"A winning new adventure featuring a stalwart warrior mouse, heroic knights, and magical Camelot." —<i>Kirkus Reviews</i></b></p><p><b>Calib’s adventures in Camelot continue in the action-packed Mice of the Round Table series! Don’t miss <i>Voyage to Avalon </i>and <i>Merlin’s Last Quest</i>.</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julie Leung
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58a5c947